import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ra-eucalypt text-ra-bone mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/restoration-logo.png"
            alt="Restoration Australia"
            className="ra-logo-img-sm mb-8"
          />
          <div className="ra-serif text-3xl md:text-4xl leading-tight">
            Building the systems<br />
            <span className="italic text-ra-bone/70">behind restoration.</span>
          </div>
          <p className="mt-6 text-ra-bone/70 max-w-md leading-relaxed">
            Restoration Australia exists to strengthen Australia's capacity to restore degraded
            landscapes, recover biodiversity, and build resilient ecological systems for future
            generations.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="ra-overline text-ra-bone/60">Explore</div>
          <ul className="mt-5 space-y-3">
            {[
              ["/focus", "Areas of Focus"],
              ["/initiatives", "Initiatives"],
              ["/partners", "Who We Work With"],
              ["/resources", "Resources"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-ra-bone/85 hover:text-ra-bone transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="ra-overline text-ra-bone/60">Get in touch</div>
          <p className="mt-5 text-ra-bone/85 leading-relaxed">
            Speak with our team about restoration partnerships, Indigenous-led enterprises, or
            biodiversity market opportunities.
          </p>
          <Link
            to="/contact"
            data-testid="footer-contact-cta"
            className="inline-block mt-6 border-b border-ra-bone/40 pb-1 text-sm tracking-[0.18em] uppercase hover:border-ra-ochre hover:text-ra-ochre transition-colors"
          >
            Contact the team →
          </Link>
        </div>
      </div>

      <div className="border-t border-ra-bone/15">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs uppercase tracking-[0.22em] text-ra-bone/60">
          <div>© {new Date().getFullYear()} Restoration Australia</div>
          <div className="italic normal-case tracking-normal text-sm text-ra-bone/70">
            Always was, always will be Aboriginal land.
          </div>
        </div>
      </div>
    </footer>
  );
}
